import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useSlugHelper } from '@/router/useSlugHelper'

const Names = {
  fr: 'annuler-un-rendez-vous',
  en: 'cancel-appt'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'Annuler un rendez-vous',
      en: 'Cancel an Appointment'
    },
    description: {
      fr: "Consultez cette page pour connaître les différentes façons d'annuler un rendez-vous.",
      en: 'Consult this page for information on how to cancel an appointment.'
    }
  },
  component: () => import('@page/cancelAppointment/CancelAppointment.vue'),
  beforeEnter: async (to, from, next) => {
    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })
    next(await useSlugHelper().checkPageSlug(to.path, Names))
  }
}

export { Config }
